import { A11yText as UDSA11yText } from '@telus-uds/components-web'

export type A11yTextProps = {
  text: string
  heading: boolean
}

const A11yText = (props: A11yTextProps) => {
  const { text, heading } = props
  return (
    <div data-testid="uds-a11ytext-id">
      <UDSA11yText text={text} heading={heading} />
    </div>
  )
}

export default A11yText
